import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { TextStyles, Radii, Colors, Shadows, Sizes, Space } from '../../types';

export const Tooltip: ComponentStyleConfig = {
  baseStyle: {
    bg: Colors.SURFACE_ELEVATED_INVERT,
    borderRadius: Radii.BASE,
    boxShadow: Shadows.XS,
    maxW: Sizes['3XS'],
    minW: Space.SPACE_4,
    minH: Space.SPACE_4,
    color: Colors.TEXT_EMPHASIS_INVERT,
    '&': { apply: `textStyles.${TextStyles.P3}` },
    py: Space['2XS'],
    px: Space.XS,
    '.chakra-tooltip__arrow': {
      '--popper-arrow-bg': `colors.${Colors.SURFACE_ELEVATED_INVERT}`,
      borderRadius: '1.5px',
    },
  },
};
